"use strict";

import { DeviceDetector } from "../systems/core/deviceDetector.js";
import { Time } from "../systems/core/time.js";
import { Mouse } from "../systems/core/mouse.js";
import { Coroutine } from "../systems/secondary/coroutine.js";
import { EventListener } from "../systems/secondary/eventListener.js";
import { AssetImporter } from "../systems/core/assetImporter.js";

export class Application extends PIXI.Application {
    static _main;
    static get main() { return Application._main; }
    
    constructor(config) {
        let device = new DeviceDetector();

        let properties = {
            legacy: true,
            antialias: false,
            resolution: device.isDesktop ? 1 : 2,
            autoResize: true,
            autoDensity: true,
            preserveDrawingBuffer: true,
            backgroundColor: 0x000000
        };

        if (config !== undefined && typeof config == "object") {
            properties = { ...properties, ...config };
        }
        
        Application._main = super(properties);

        this._device = device;
        this._input = device.isDesktop ? {
            "down": "mousedown",
            "up": "mouseup",
            "upoutside": "mouseupoutside",
            "over": "mouseover",
            "out": "mouseout",
            "move": "mousemove"
        } : {
            "down": "touchstart",
            "up": "touchend",
            "upoutside": "touchendoutside",
            "over": "mouseover",
            "out": "mouseout",
            "move": "touchmove"
        };
        this._hwAccelerationSupported = PIXI.utils.isWebGLSupported();
        this._worldCenter = { x: 0, y: 0 };

        this._ticker = PIXI.Ticker.shared;
        this._ticker.autoStart = true;
        this._ticker.add(Time._update);

        this._mouse = this.renderer.plugins.interaction.mouse;
        
        document.body.appendChild(this.view);

        this.onFocusChangedListener = new EventListener("onFocusChanged");
        this._windowHasFocus = true;
        this._windowFocusChanged = false;
        document.addEventListener("visibilitychange", () => {
            this._windowHasFocus = document.visibilityState == "visible";
            this.onFocusChangedListener.dispatch(this._windowHasFocus);
            Time._ignoreLastFrame = true;
        });

        AssetImporter.initialize(this.loader);

        Mouse.enableMouseMoveFlag();

        this._ticker.add(Coroutine._update);

        //
        // The following won't work because of
        // PIXI.Screen in the Application
        // this.screen = new Screen();
        //
    }

    get device() {
        return this._device;
    }
    get input() {
        return this._input;
    }
    get ticker() {
        return this._ticker;
    }
    get mouse() {
        return this._mouse;
    }

    get hardwareAccelerationSupported() {
        return this._hwAccelerationSupported;
    }

    get windowHasFocus() {
        return this._windowHasFocus;
    }

    get worldCenter() {
        return {...this._worldCenter};
    }
    get worldCenterX() {
        return this._worldCenter.x;
    }
    get worldCenterY() {
        return this._worldCenter.y;
    }

    setWorldCenter(x,y) {
        if (x === undefined) return;
        this._worldCenter.x = x.x ?? x;
        this._worldCenter.y = x.y ?? y;
    }

    static showcaseVersion() {
        console.log("%c SIMPLE-ENGINE " + Application.version + " ",
            "background: #222; color: #bada55; padding: 10px");
    }
    static get version() { return "1.2.8.2"; }
}